const STORAGE_KEY = 'admin-header-notifications';
const MAX_STORED = 500;

/**
 * @typedef {Object} StoredNotification
 * @property {number} id
 * @property {string} timestamp
 * @property {string} title
 * @property {string} [message]
 * @property {string} [type]
 * @property {boolean} [read]
 * @property {Record<string, unknown>} [meta]
 */

/**
 * @returns {StoredNotification[]}
 */
export function loadStoredNotifications() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed
      .filter((n) => n && typeof n === 'object' && n.id != null)
      .slice(-MAX_STORED);
  } catch {
    return [];
  }
}

/**
 * @param {StoredNotification[]} notifications
 */
export function saveStoredNotifications(notifications) {
  try {
    const trimmed = Array.isArray(notifications)
      ? notifications.slice(-MAX_STORED)
      : [];
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    /* quota or private mode */
  }
}

export function createNotificationId() {
  return Date.now() + Math.floor(Math.random() * 1000);
}
